import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { FormattedMessage } from 'react-intl';
import { AutomaticClosingConfirmation } from './caseClosingConfirmation';

const TEXT_IDS: Record<AutomaticClosingConfirmation, { titleId: string; contentId: string; confirmId: string }> = {
    [AutomaticClosingConfirmation.SWITCH_ON]: {
        titleId: 'case-closing-config.switch-on-confirmation-title',
        contentId: 'case-closing-config.switch-on-confirmation-text',
        confirmId: 'case-closing-config.switch-on',
    },
    [AutomaticClosingConfirmation.CHANGE]: {
        titleId: 'case-closing-config.change-confirmation-title',
        contentId: 'case-closing-config.change-confirmation-text',
        confirmId: 'save',
    },
};

interface Props {
    confirmation: AutomaticClosingConfirmation;
    caseCount: number;
    onCancel: () => void;
    onConfirm: () => void;
}

export function AutomaticClosingConfirmationModal({ confirmation, caseCount, onCancel, onConfirm }: Props) {
    const { titleId, contentId, confirmId } = TEXT_IDS[confirmation];
    return (
        <ConfirmationModal
            titleId={titleId}
            confirmId={confirmId}
            content={
                <p className="text-body1">
                    <FormattedMessage id={contentId} values={{ count: caseCount }} />
                </p>
            }
            onCancel={onCancel}
            onConfirm={onConfirm}
        />
    );
}
